document.addEventListener('DOMContentLoaded', () => {
	const dropdowns = document.querySelectorAll('.select');

	dropdowns.forEach((dropdown) => {
		const select = dropdown.querySelector('select');
		const options = Array.from(select.options);
		const display = document.createElement('div');
		const optionsContainer = document.createElement('div');

		display.className = 'select__display';
		display.textContent = options.find((opt) => opt.selected)?.textContent || options[0].textContent;

		optionsContainer.className = 'select__options';

		// Optionen aus dem <select> generieren
		options.forEach((opt) => {
			const optionEl = document.createElement('div');
			optionEl.className = 'select__option';
			optionEl.dataset.value = opt.value;
			optionEl.textContent = opt.textContent;

			optionEl.addEventListener('click', () => {
				// Setze Value im <select>
				select.value = opt.value;
				// Trigger native Events (z. B. für Filter)
				select.dispatchEvent(new Event('change'));

				// Anzeige aktualisieren
				display.textContent = opt.textContent;
				optionsContainer.classList.remove('open');
			});

			optionsContainer.appendChild(optionEl);
		});

		dropdown.appendChild(display);
		dropdown.appendChild(optionsContainer);

		// Klick auf Display toggelt Dropdown
		display.addEventListener('click', (e) => {
			e.stopPropagation();
			optionsContainer.classList.toggle('is-open');
		});

		// Klick außerhalb schließt Dropdown
		document.addEventListener('click', () => {
			optionsContainer.classList.remove('is-open');
		});
	});
});
